import styled from 'styled-components';

export const SelectWrapper = styled.div`
  position: relative;
`;

export const Icon = styled.div<{ open: boolean }>`
  position: absolute;
  right: 12px;
  top: 12px;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};
  transform-origin: center;
  height: 24px;
  width: 24px;
  transition: transform 0.2s ease-in-out;
`;

export const SelectBox = styled.select<{ error?: string }>`
  // Reset
  appearance: none;
  margin: 0;
  width: 100%;
  font-family: inherit;
  cursor: inherit;
  line-height: inherit;
  // Own
  background-color: white;
  border-radius: 4px;
  border: 1px solid ${({ error }) => (error ? 'var(--colorWarning)' : 'rgb(213, 215, 216)')};
  padding: 12px 16px 16px;
  font-size: 14px;
  font-weight: 600;
`;
